import { SiteMap } from 'containers/Static/SiteMap/index'
import { mapStateToProps } from 'containers/Static/SiteMap/index.props'
import { connect } from 'react-redux'

const SiteMapStore = connect(mapStateToProps)(SiteMap)

export { SiteMapStore }


